export enum VariantKeys {
  dimensionAndWeight = 'Dimensions and Weight',
  capacity = '',
  supension = '',
  safety = '',
  brakingAndTraction = '',
  locksAndSecurity = '',
  comfortAndConvenience = '',
  seatsAndUpholstery = '',
}

export const DETAIL_KEYS = {
  'Dimensions and Weight': 'dimensionAndWeight',
  'Engine and Transmission': 'engineAndTransmission',
  Capacity: 'capacity',
  'Suspension, Brakes, Steering and Tyres': 'suspension',
  Safety: 'safety',
  'Braking and Traction': 'brakingAndTraction',
  'Lock and Security': 'lockAndSecurity',
  'Comfort and Convenience': 'comfortAndConvenience',
  Telematics: 'telematics',
  Exterior: 'exterior',
  Lighting: 'lighting',
  'Doors Windows Mirrors and Wipeers': 'doorsAndWindows',
  'Entertainment Information and Communication': 'entertainmentAndComm',
  'On road price by city': 'onRoadPrice',
};

export const KEY_VALUE = {
  dimensionAndWeight: 'Dimensions and Weight',
  engineAndTransmission: 'Engine and Transmission',
  capacity: 'Capacity',
  suspension: 'Suspension, Brakes, Steering and Tyres',
  safety: 'Safety',
  brakingAndTraction: 'Braking and Traction',
  lockAndSecurity: 'Lock and Security',
  comfortAndConvenience: 'Comfort and Convenience',
  telematics: 'Telematics',
  exterior: 'Exterior',
  lighting: 'Lighting',
  doorsAndWindows: 'Doors Windows Mirrors and Wipeers',
  entertainmentAndComm: 'Entertainment Information and Communication',
  onRoadPrice: 'On road price by city',
};
